export default class LazyImageLoader {
    constructor() {
        this.attributeName = 'data-lazy-load';
        this.observedElementsSelector = `[${this.attributeName}]`;
        this.init();
    }

    init() {
        const observedElements = document.querySelectorAll(this.observedElementsSelector);
        if (observedElements.length === 0) {
            return false;
        }
        if (typeof IntersectionObserver === typeof undefined) {
            observedElements.forEach((element) => {
                this.setImageSource(element);
            });
            return;
        }

        document.addEventListener('DOMContentLoaded', () => {
            this.observer = this.getObserver();
            this.observe(observedElements, this.observer);
        });
    }

    /**
     * returns instance of IntersectionObserver
     * @return IntersectionObserver
     */
    getObserver() {
        return new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.setImageSource(entry.target);
                    this.observer.unobserve(entry.target);
                }
            });
        });
    }

    /**
     * uses the dataset to set the image src
     * @param {*} lazyImage
     */
    setImageSource(lazyImage) {
        if (lazyImage.dataset.src) {
            lazyImage.src = lazyImage.dataset.src;
        }
        lazyImage.removeAttribute('data-lazy');
    }

    /**
     * observes elements with IntersectionObserver
     * @param {*} observedElements
     * @param {*} observer
     */
    observe(observedElements, observer) {
        for (let i = 0; i < observedElements.length; i++) {
            observer.observe(observedElements[i]);
        }
    }
}
